import { api, addCursorLoader, removeCursorLoader } from 'dmui_components'
import { ref, onMounted } from 'vue'

/**
 * Save user settings
 * @param {*} data
 */
const saveUserSettings = async (body) => {
	addCursorLoader()
	try {
		await api(`/current_user/settings`, {
			method: 'PUT',
			body
		})
	} catch (e) {
		console.error('Error while updating settings', e)
		throw e
	}
	removeCursorLoader()
}

/**
 * Get User Settings
 * @param {*} settings
 * @returns
 */
const getUserSettings = async () => {
	try {
		return await api(`/current_user/settings`)
	} catch (e) {
		console.error('Error while getting user settings', e)
		throw e
	}
}

/**
 * Composable to always return latest value of settings and
 * update it
 * @returns {userSettings, saveUserSettings}
 */
export default function useUserSettings() {
	const userSettings = ref({})
	const loading = ref(true)
	onMounted(async () => {
		loading.value = true
		userSettings.value = await getUserSettings()
		loading.value = false
	})
	return {
		userSettings,
		saveUserSettings: async (data) => {
			loading.value = true
			await saveUserSettings(data)
			userSettings.value = {
				...userSettings.value,
				...data
			}
			loading.value = false
		},
		loading
	}
}
